import { createFileRoute, redirect } from "@tanstack/react-router";

/** Comparison charts have moved into the Visuals studio; keep the old URL working. */
export const Route = createFileRoute("/_authenticated/charts")({
  beforeLoad: () => {
    throw redirect({ to: "/visuals", replace: true });
  },
});
